export default [
  {
    path: "/service-locations",
    name: "service-locations",
    component: () => import("@/modules/service-locations/ServiceLocations.vue"),
    children: [
      {
        path: "list",
        name: "list-service-locations",
        component: () =>
          import("@/modules/service-locations/pages/ServiceLocationsList.vue"),
        meta: { permissions: ["service-locations-show"] }
      },
      {
        path: "add",
        name: "add-service-locations",
        component: () =>
          import("@/modules/service-locations/pages/ServiceLocationsAdd.vue"),
        meta: { permissions: ["service-locations-create"] }
      },
      {
        path: "edit/:id",
        name: "edit-service-locations",
        component: () =>
          import("@/modules/service-locations/pages/ServiceLocationsEdit.vue"),
        meta: { permissions: ["service-locations-update"] }
      }
    ]
  }
];
